import $ from "jquery"
import { trace } from "rytm-helpers"
require('jquery-autocomplete');

/**
 * ###############
 * ### Helpers ###
 */
// get all form hints
const getFormHints = (wrapperSelector) => {
  let result = []
  const elements = getSearchableElements(wrapperSelector)
  elements.forEach((el) => {
    result.push(el.dataset.liveSearchValue)
  })
  return result
}
// get all searchable elements in one array
const getSearchableElements = (wrapperSelector) => {
  let list = []
  const wrappers = wrapperSelector ? [...document.querySelectorAll(wrapperSelector)] : []
  wrappers.forEach((wrapper) => {
    list = [...list, ...wrapper.querySelectorAll("*[data-live-search-value]")]
  })
  return list
}
// test - czy element posiada frazę
const testElement = (el, val) => {
  let result = true
  if (val && el.dataset.liveSearchValue) {
    result = el.dataset.liveSearchValue.toLowerCase().indexOf(val.toLowerCase()) >= 0
  }
  return result
}
// usuń etykietę "brak wyników"
const removeNoResultsLabel = (wrapper) => {
  const list = [...wrapper.querySelectorAll(".live-no-results")]
  list.forEach((el) => {
    el.parentNode.removeChild(el)
  })
}
// dodaj etykietę "brak wyników"
const addNoResultsLabel = (wrapper, txt) => {
  let node = document.createElement("div"); 
  node.classList.add("live-no-results")
  node.innerHTML = txt
  wrapper.appendChild(node)
}

/**
 * ######################
 * ### Event handlers ###
 */
const onLiveInputKeyUp = (e) => {
  const inpt = e.currentTarget
  const form = inpt.closest("form")
  // przechodzę przez listy oddzielnie, żeby aktualizować label "brak wyników"
  const wrappers = [...document.querySelectorAll(form.dataset.liveSearch)]
  const noResultsTxt = form.dataset.noResultsMsg
  wrappers.forEach((wrapper) => {
    let anyFound = false
    const elements =  [...wrapper.querySelectorAll("*[data-live-search-value]")]
    elements.forEach((el) => {
      if (testElement(el, inpt.value)) {
        anyFound = true
        el.classList.remove("war-no-match")
      } else {
        el.classList.add("war-no-match")
      }
    })
    if (anyFound) {
      removeNoResultsLabel(wrapper)
    } else if (!wrapper.querySelector(".live-no-results")) {
      addNoResultsLabel(wrapper, noResultsTxt)
    }

  })
  
}


/**
 * ########################
 * ### Public interface ###
 */
export const refreshWarLiveSearch = () => {
  const inpt = document.querySelector("form[data-live-search] input")
  if (inpt) {
    const form = inpt.closest("form")
    const keywords = getFormHints(form.dataset.liveSearch)
    const params = {
      source: [keywords],
      limit: 0
    }
    $(inpt).autocomplete(params)
  }
}

export const initWarLiveSearch = () => {
  $("body").on("keyup", "form[data-live-search] input", onLiveInputKeyUp);
}